/** A numeric route segment (`/v/:virtualAccountId`, `/e/:envelopeId`); `null` for anything else. */
export function parseRouteId(raw: string | undefined): number | null {
  if (raw === undefined || !/^\d+$/.test(raw)) return null;
  return Number(raw);
}
